var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxTableUnselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 17.5H16.5768C17.496 17.5 18.2435 16.7525 18.2435 15.8333V4.16667C18.2435 3.2475 17.496 2.5 16.5768 2.5H3.33268C2.41352 2.5 1.66602 3.2475 1.66602 4.16667V15.8333C1.66602 16.7525 2.41352 17.5 3.33268 17.5ZM3.33268 15.8333V11.6667H6.66602V15.8333H3.33268ZM11.666 5.83333V10H8.33268V5.83333H11.666ZM6.66602 5.83333V10H3.33268V5.83333H6.66602ZM8.33268 15.8333V11.6667H11.666V15.8333H8.33268ZM13.3327 15.8333V11.6667H16.5777V15.8333H13.3327ZM16.5768 10H13.3327V5.83333H16.5768V10Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTableUnselect);
export default __webpack_public_path__ + "static/media/bx-table-unselect.aa819579acb7c118c00eeafe4bf16170.svg";
export { ForwardRef as ReactComponent };